<template>
<!-- 辞书世界 - 轮播图管理 -->
  <div class="container">
    <div class="operation-condition">
      <div>
        <el-input
          placeholder="请输入关键字"
          v-model.trim="searchInfo"
          style="min-width: 300px;"
        >
          <el-button type="primary" slot="append" @click="searchHandler"
            >搜索</el-button
          >
        </el-input>

        <!-- <el-button type="error"  @click="CreateIndex"
            >创建索引</el-button
          > -->
      </div>
      <div style="float: right;">
        <el-button v-on:click="addActivity" type="primary" style="width: 80px"
          >新建</el-button
        >
        <el-button
          type="danger"
          style="width: 80px"
          v-bind:disabled="delDisable"
          v-on:click="delClick"
          >删除</el-button
        >
      </div>
    </div>
    <div class="table_div">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#eef1f6' }"
        >
        <el-table-column align="center" type="selection" width="55"/>
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="120"
          >
        </el-table-column>
        <el-table-column
          prop="name"
          label="昵称"
          align="center"
          >
        </el-table-column>

        <el-table-column
          prop='email'
          align="center"
          label="邮箱">
        </el-table-column>
        <el-table-column
          prop="operate"

          align="center"
          width="260"
          label="操作">
          <template slot-scope="scope">
            <el-tooltip style="margin-right:10px" :content="scope.row.status=='0'?'开启':'关闭'" placement="top">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="0"
                inactive-value="1"

                @change="changeToggle(scope.row)"
                >
              </el-switch>
            </el-tooltip>
            <i class="el-icon-edit" @click="handleClick(scope.row)"></i>
            <i class="el-icon-delete" @click="handleDeleteClick(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :visible.sync="dialogVisible">
      </el-dialog>
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.page_num"
          :page-size="pagenation.page_size"
          background
          layout="total, prev, pager, next"
          :total="pagenation.total">
        </el-pagination>
      </div>
      <AddEmailDialog ref="addDialog"/>
    </div>
  </div>
</template>

<script>
import emailApi from '@/api/email'
import { mapRequestActions } from '@/utils'
import { MessageBox } from 'element-ui'
import AddEmailDialog from './components/add-email'
export default {
  components: {
    AddEmailDialog
  },
  data () {
    return {
      loading: false,
      dialogVisible: false,

      searchInfo: '',
      options: [],
      selectArr: [],
      delDisable: true,
      tableData: [],
      pagenation: {
        page_num: 1,
        page_size: 10,
        total: 0
      }
    }
  },
  created () {
    this.handleEmailList()
  },
  methods: {
    ...mapRequestActions(emailApi),
    /**
     * 分页
     */
    handleCurrentChange (newPage) {
      this.pagenation = Object.assign({}, this.pagenation, { newPage })
      this.handleEmailList()
    },

    // CreateIndex () {
    //   this.CreateEmailAction().then(res => {
    //     console.log('res==', res)
    //   })
    // },

    /**
     * 获取banner图片列表
     */
    handleEmailList () {
      this.getEmailListAction({
        name: this.searchInfo,
        pageNum: this.pagenation.page_num,
        pageSize: this.pagenation.page_size
      }).then(res => {
        if (res.status) {
          this.pagenation = Object.assign({}, this.pagenation, {
            currentPage: 1,
            total: res.result.total
          })
          this.tableData = res.result.rows || []
        }
      })
    },

    searchHandler () {
      this.handleEmailList()
    },

    // selected items change
    handleSelectionChange (arr) {
      this.selectArr = arr
      if (arr.length !== 0) {
        this.delDisable = false
      } else {
        this.delDisable = true
      }
    },
    /**
     * 开启 关闭键
     */
    async changeToggle (type) {
      const data = await this.updateEmailAction({
        id: type.id,
        name: type.name,
        email: type.email,
        status: type.status
      })
      if (data.status) {
        this.handleEmailList()
      } else {
        this.$message.error('操作失败')
      }
    },

    /**
     * 新增
     */
    addActivity () {
      this.$refs.addDialog.showAddDialog()
    },
    /**
     * 编辑
     */
    handleClick (item) {
      console.log('111', item)
      this.$refs.addDialog.showEditDialog(item.id)
    },
    /**
     * 删除 全选操作
     */
    delClick () {
      const _this = this
      MessageBox.confirm('此操作将永久删除该账号, 是否继续?', '提示').then(() => {
        const longIds = _this.selectArr.map(item => item.id)
        this.deleteEmailAction({ longIds }).then(res => {
          if (res.status) {
            _this.$message({
              type: 'success',
              message: '删除成功'
            })
            _this.handleEmailList()
          } else {
            _this.$message.error(res.errorMsg || '删除失败')
          }
        })
      })
    },
    /**
     * 删除 单选操作
     */
    handleDeleteClick (item) {
      const _this = this
      MessageBox.confirm('此操作将永久删除该账号, 是否继续?', '提示').then(() => {
        const longIds = [item.id]
        this.deleteEmailAction({ longIds }).then(res => {
          if (res.status) {
            _this.$message.success('删除成功')
            _this.handleEmailList()
          } else {
            _this.$message.error(res.errorMsg || '删除失败')
          }
        })
      })
    }
  }

}
</script>

<style lang='less' scoped>
@import "../banner/index.less";
</style>
